<template>
  <div class="xv_view" id="Testing_center_G">
    <div class="xv_top">
      <div>
        <label class="xv_view_title">Testing Centers</label>
      </div>
      <div class="xv_actions">
        <button class="sec_btn m_r" @click="import_testing_center()">
          Import
          <span class="mdi mdi-cloud-download-outline"></span>
        </button>
        <button class="main_btn" @click="add_testing_center()">
          New Testing Center
          <span class="mdi mdi-plus-thick"></span>
        </button>
      </div>
    </div>
    <div class="xv_table">
      <div class="xv_table_title">
        <div>
          <span>Testing Centers (7)</span>
        </div>
        <div class="table_search">
          <span class="mdi mdi-magnify"></span>
          <input type="text" placeholder="Search by Center" />
        </div>
      </div>
      <table class="office_table">
        <thead>
          <tr>
            <th style="width:20%">Name</th>
            <th style="width:16%;text-align:center">State</th>
            <th style="width:16%;text-align:center">District</th>
            <th style="width:16%;text-align:center">City</th>
            <th style="width:16%;text-align:center">Doctors</th>
            <th style="width:16%;text-align:center">Status</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              <span id="kaiser" @click="view_testing_center">Kaiser</span>
            </td>
            <td>
              <span>United States</span>
            </td>
            <td>
              <span>Yishun</span>
            </td>
            <td>
              <span>Yoohan</span>
            </td>
            <td>
              <span>18</span>
            </td>
            <td class="status_1">
              <span>Ok</span>
            </td>
          </tr>
          <tr>
            <td>
              <span id="mediclinic" @click="view_testing_center">Mediclinic</span>
            </td>
            <td>
              <span>United States</span>
            </td>
            <td>
              <span>Tampines</span>
            </td>
            <td>
              <span>Champeg</span>
            </td>
            <td>
              <span>22</span>
            </td>
            <td class="status_1">
              <span>Ok</span>
            </td>
          </tr>
          <tr>
            <td>
              <span id="American Hospital" @click="view_testing_center">American Hospital</span>
            </td>
            <td>
              <span>United States</span>
            </td>
            <td>
              <span>Hougang</span>
            </td>
            <td>
              <span>Lebanon</span>
            </td>
            <td>
              <span>30</span>
            </td>
            <td class="status_1">
              <span>Ok</span>
            </td>
          </tr>
          <tr>
            <td>
              <span id="Fortis" @click="view_testing_center">Fortis</span>
            </td>
            <td>
              <span>United States</span>
            </td>
            <td>
              <span>Tampines</span>
            </td>
            <td>
              <span>Retro</span>
            </td>
            <td>
              <span>22</span>
            </td>
            <td class="status_1">
              <span>Ok</span>
            </td>
          </tr>
          <tr>
            <td>
              <span id="carilione" @click="view_testing_center">Carilione</span>
            </td>
            <td>
              <span>Switzerland</span>
            </td>
            <td>
              <span>Pasir Ris</span>
            </td>
            <td>
              <span>Venis</span>
            </td>
            <td>
              <span>32</span>
            </td>
            <td class="status_2">
              <span>Closed</span>
            </td>
          </tr>
          <tr>
            <td>
              <span id="Tencent" @click="view_testing_center">Pacifica Salud</span>
            </td>
            <td>
              <span>Greater China</span>
            </td>
            <td>
              <span>Pasir Ris</span>
            </td>
            <td>
              <span>Reius</span>
            </td>
            <td>
              <span>32</span>
            </td>
            <td class="status_2">
              <span>Closed</span>
            </td>
          </tr>
          <tr>
            <td>
              <span id="global" @click="view_testing_center">Global Hospitals</span>
            </td>
            <td>
              <span>Greater China</span>
            </td>
            <td>
              <span>Hougang</span>
            </td>
            <td>
              <span>Siezure</span>
            </td>
            <td>
              <span>30</span>
            </td>
            <td class="status_1">
              <span>Ok</span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <!-- Add office modal -->
    <modal name="add_testing_center" transition="pop-out" :width="600" height="auto">
      <addTestingCenter></addTestingCenter>
    </modal>
    <!-- Import office modal -->
    <modal name="import_testing_center" transition="pop-out" :width="600" height="auto">
      <importTestingCenter></importTestingCenter>
    </modal>
  </div>
</template>

<script>
import addTestingCenter from "./add_testing_center/addTestingCenter.vue";
import importTestingCenter from "./import_testing_center/importTestingCenter.vue";

export default {
  name: "Testing_center_G",
  components: {
    addTestingCenter,
    importTestingCenter
  },
  data() {
    return {};
  },
  mounted() {},
  methods: {
    add_testing_center: function() {
      this.$modal.show("add_testing_center");
    },
    import_testing_center: function() {
      this.$modal.show("import_testing_center");
    },
    view_testing_center: function(e) {
      var id = e.currentTarget.id;
      this.$router.push("/xv-admin-g/testing_centers:" + id);
    }
  }
};
</script>
